export default __webpack_public_path__ + "static/media/logo-us-zappos.55a9d143.svg";